import { useTranslation } from "react-i18next";
import { HiOutlineDocumentText } from "react-icons/hi";
import { LanguageChanger } from "../dashboard/Layout";

interface UnknownProcessTypeViewProps {
  processType?: string;
}

const UnknownProcessTypeView = ({
  processType,
}: UnknownProcessTypeViewProps) => {
  const { t, i18n } = useTranslation("clientView");

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-7 bg-gray-50">
      <div className="max-w-md text-center bg-white rounded-lg shadow-lg p-8">
        <div className="w-16 h-16 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
          <HiOutlineDocumentText className="w-8 h-8 text-gray-400" />
        </div>

        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          {t("error.processNotAvailable")}
        </h3>

        <p className="text-gray-600 leading-relaxed">
          {t("error.processNotAvailableDescription")}
        </p>

        {processType && (
          <div className="bg-gray-100 rounded-lg p-3 mt-6">
            <p className="text-gray-500 text-sm">
              {t("error.technicalInfo")}:
              <span className="font-mono text-gray-700 ml-1">
                {processType}
              </span>
            </p>
          </div>
        )}
      </div>
      <div className="mt-6">
        <LanguageChanger i18n={i18n} className="bg-gray-400" />
      </div>
    </div>
  );
};

export default UnknownProcessTypeView;
